import './App.css';

import React from 'react'

import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';


import { ListGroup } from 'react-bootstrap';

import TranslateWidget from './components/utils/TranslateWidget'; // Adjust the import path as needed

import LandingScreen from './screens/LandingScreen'

import ExamplesScreen from './screens/ExamplesScreen'
import DocsScreen from './screens/DocsScreen'
import NodesScreen from './screens/NodesScreen'
import CustomNodesScreen from './screens/CustomNodesScreen'
import AgentsScreen from './screens/AgentsScreen'

//Examples
import Example_SimpleRAG from './components/tutorials/Example_SimpleRAG'
import QuickStart from './components/tutorials/QuickStart'
import LLMChat from './components/tutorials/LLMChat'
//Components
import Header from './components/layout/Header'
import Footer from './components/layout/Footer'
import DocNavbar from './components/layout/DocNavbar'

import FlowViewSimpleScreen from './screens/FlowViewSimpleScreen'

import TermsandConditionsScreen from './screens/TermsandConditionsScreen'
import PrivacyPolicyScreen from './screens/PrivacyPolicyScreen'

const App = () => {

  return (

    <Router>

      <Header />
    

      <TranslateWidget />

      {/* <AlertComponent /> */}

      <main style={{margin:'0px', padding:'0px'}}>

        <Routes>

          <Route path='/' element={<LandingScreen />} exact />

          <Route path='/docs/getting-started' element={<DocsScreen />} exact />
          <Route path='/docs/custom-nodes' element={<CustomNodesScreen />} exact />
          <Route path='/docs/agents' element={<AgentsScreen />} exact />

          {/* <Route path='/docs/view' element={<LaeyerzViewScreen />} exact /> */}

          {/* <Route path='/reference/nodes' element={<NodesScreen />} exact /> */}

      
          <Route path='/examples' element={<ExamplesScreen />} exact />
          <Route path='/examples/quick-start' element={<QuickStart />} exact />
          <Route path='/examples/llm-chat' element={<LLMChat />} exact />

          {/* <Route path='/flowview' element={<FlowViewSimpleScreen />} exact /> */}


       
          <Route path='/terms-and-conditions' element={<TermsandConditionsScreen />} exact /> 
          <Route path='/privacy-policy' element={<PrivacyPolicyScreen />} exact /> 
       
        </Routes>

      </main>

      <Footer />

    </Router>

  );
}

export default App;



